import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@/components/data-grid';
import { ROUTES } from '@/app/routes';
import {
  useCoopModerationCases,
  useCoopModerationMetrics,
  type ProactiveCase,
} from '@/features/moderation/api';
import { proactiveColumns } from '@/features/moderation/columns';

/**
 * Content Management → Auto Reject.
 * Lists TipMi ledger REJECTED cases that were pipeline auto-rejects only
 * (human moderator rejects are excluded server-side). Row opens content detail.
 */
export function AutoRejectPage() {
  const navigate = useNavigate();
  const table = useCoopModerationCases('rejected');
  const metrics = useCoopModerationMetrics();
  const rejectedToday = metrics.data?.autoRejectedToday ?? 0;

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-lg font-semibold">Auto Reject</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Posts auto-rejected by the moderation pipeline. Human moderator rejects are not listed here.
          </p>
        </div>
        <span className="rounded-md border bg-muted/40 px-3 py-1.5 text-sm text-muted-foreground">
          {rejectedToday} today
        </span>
      </div>

      <div className="min-h-0 flex-1">
        <DataGrid<ProactiveCase>
          title="Auto Reject Queue"
          searchPlaceholder="Search auto-rejected content…"
          columns={proactiveColumns}
          rows={table.rows}
          total={table.total}
          isLoading={table.isLoading}
          isFetchingNextPage={table.isFetchingNextPage}
          isError={table.isError}
          error={table.error}
          endReached={table.endReached}
          page={table.page}
          totalPage={table.totalPage}
          onPageChange={table.setPage}
          isFetching={table.isFetching}
          onLoadMore={table.fetchNextPage}
          onRetry={() => void table.refetch()}
          search={table.search}
          onSearchChange={table.setSearch}
          onRowClick={(row) => {
            if (row.post_id != null) {
              void navigate(ROUTES.contentDetails(String(row.post_id)));
            }
          }}
          getRowId={(row) => row.case_id}
          emptyMessage="No auto-rejected posts."
        />
      </div>
    </div>
  );
}
